import { render, staticRenderFns } from "./V2WishlistProducts.vue?vue&type=template&id=22a199ca&scoped=true&"
import script from "./V2WishlistProducts.vue?vue&type=script&lang=js&"
export * from "./V2WishlistProducts.vue?vue&type=script&lang=js&"
import style0 from "./V2WishlistProducts.vue?vue&type=style&index=0&id=22a199ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a199ca",
  null
  
)

export default component.exports